import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Instructions.css';

const Instructions = () => {
  const navigate = useNavigate();

  // Función para manejar el regreso a la página principal
  const handleBackToHome = () => {
    // Navegar a la página principal sin detener la música
    navigate('/');
  };

  return (
    <div className="instructions-container">
      <div className="instructions-content">
        <h1>Instrucciones</h1>
        
        <div className="instruction-section">
          <h2>¿Cómo jugar?</h2>
          <div className="instruction-step">
            <div className="step-number">1</div>
            <div className="step-content">
              <h3>Degustación</h3>
              <p>Probá las tres mieles.</p>
              <div className="step-animation honey-tasting">
                {/* Eliminamos cualquier texto superpuesto aquí */}
              </div>
            </div>
          </div>
          
          <div className="instruction-step">
            <div className="step-number">2</div>
            <div className="step-content">
              <h3>Identificación</h3>
              <p>Para cada muestra, seleccioná qué tipo de miel creés que es entre las tres opciones.</p>
              <div className="step-animation honey-selection">
                {/* Eliminamos cualquier texto superpuesto aquí */}
              </div>
            </div>
          </div>
          
          <div className="instruction-step">
            <div className="step-number">3</div>
            <div className="step-content">
              <h3>Pistas</h3>
              <p>Si necesitás ayuda, podés usar hasta 3 pistas durante el juego. Cada pista reduce tu puntuación.</p>
              <div className="step-animation hint-usage">
                {/* Eliminamos cualquier texto superpuesto aquí */}
              </div>
            </div>
          </div>
          
          <div className="instruction-step">
            <div className="step-number">4</div>
            <div className="step-content">
              <h3>Resultados</h3>
              <p>Al finalizar, verás cuántas mieles identificaste correctamente y tu puntuación final.</p>
              <div className="step-animation results-view">
                {/* Eliminamos cualquier texto superpuesto aquí */}
              </div>
            </div>
          </div>
        </div>
        
        <div className="instruction-section scoring-section">
          <h2>Sistema de Puntuación</h2>
          <ul className="scoring-list">
            <li className="scoring-item">
              <span className="score-item">Puntuación inicial:</span>
              <span className="score-value">300 puntos</span>
            </li>
            <li className="scoring-item">
              <span className="score-item">Cada pista utilizada:</span>
              <span className="score-value">-50 puntos</span>
            </li>
            <li className="scoring-item">
              <span className="score-item">Identificación correcta:</span>
              <span className="score-value">¡Mantenés puntos!</span>
            </li>
            <li className="scoring-item">
              <span className="score-item">Identificación incorrecta:</span>
              <span className="score-value">-100 puntos</span>
            </li>
          </ul>
        </div>
        
        <div className="instruction-section">
          <h2>Modo Competitivo</h2>
          <p>En el modo competitivo, tu puntuación se guardará en una tabla de clasificación. ¡Competí con amigos para ver quién es el verdadero Maestro de la Miel!</p>
        </div>
        
        <button 
          className="btn btn-primary back-btn"
          onClick={handleBackToHome}
        >
          Volver al Inicio
        </button>
      </div>
    </div>
  );
};

export default Instructions;
